module.exports = __webpack_public_path__ + "static/media/circle.c4af048f.svg";